import * as axios from 'axios';
import * as utils from '../shared/service-utils';

import { API } from '../shared/config';

export default {
  methods: {
    async getAdnProfileForPP(userId) {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.get(`${API}/customer/ext-profile/${userId}`, { headers: hdr });
        const data = this.parseCycleData(response);
        return data;
      } catch (error) {
        console.error(error);
        return {};
      }
    },
    parseCycleData(response) {
      if (response.status !== 200) throw Error(response.message);
      if (!response.data) return {};
      const rawData = response.data;
      return rawData;
    },
  },
};
